import React from "react";
import * as c from "./lcContactBlock.module.scss";
import { graphql, useStaticQuery, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { Button } from "@components/shared";

export default function LcContactBlock({ className }) {
  const data = useStaticQuery(graphql`
    {
      chatIcon: file(relativePath: { eq: "learning-center/chat-icon.png" }) {
        childImageSharp {
          gatsbyImageData(width: 60, quality: 90, layout: FIXED)
        }
      }
    }
  `);

  const openIntercom = (e) => {
    e.preventDefault();
    window?.Intercom && window.Intercom("show");
  };

  return (
    <div className={classNames(c.container, className)}>
      <GatsbyImage image={getImage(data.chatIcon)} alt="Start a chat with us" />
      <div className={c.text}>
        <h2 className={c.title}>Can't find what you're looking for?</h2>
        <p className={c.description}>
          <Button className={c.link} asHtmlButton variant="link" onClick={openIntercom}>
            Start a chat
          </Button>{" "}
          with us to talk to a real person and get your questions answered, or browse our{" "}
          <Link className={c.link} to="/videos/">
            on-demand videos
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
